import axios from 'axios'

export default {
  getCompany (companyId, withDropShipAddress = false) {
      return axios.get(`/api/company/company-info/${companyId}?withDropShipAddress=${withDropShipAddress}`)
  },
  updateCompanyInfo (companyId, payload) {
    return axios.patch(`/api/company/${companyId}/update`, { ...payload })
  },
  addCompanyAddress (payload) {
    return axios.post('/api/address', payload)
  },
  updateCompanyAddress (id, payload, extra) {
    return axios.patch(`/api/address/${id}/update`, { ...payload})
  },
  updateCompanyBuyer (buyerId, payload) {
    return axios.patch(`/api/buyer/${buyerId}/update`, payload)
  },
  addCompanyBuyer (payload) {
    return axios.post('/api/buyer', payload)
  },
  deleteCompanyBuyer (id, payload) {
    return axios.delete(`/api/buyer/${id}/destroy`, payload)
  },
  fetchCompanies (params = {}) {
    return axios.get('/api/companies', { params })
  },
  deleteCompany (companyId) {
    return axios.delete(`/api/company/${companyId}/destroy`)
  },
  
  // Column management for contact management
  getCompanyColumns() {
    return axios.get('/api/admin/companies/columns')
  },
  updateCompanyColumn(name) {
    return axios.post('/api/admin/companies/columns/update', { name })
  },
  updateCompanyColumnOrder(orderedColumns) {
    return axios.post('/api/admin/companies/columns/update-order', { ordered_columns: orderedColumns })
  },
  uploadLogo (companyId, formData) {
      formData.append('company_id', companyId)
      return axios.post('/api/company/upload-logo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
      })
  },
  getCompanyLogos (companyId) {
    return axios.get(`/api/company/${companyId}/logo`)
  },
  activateCompanyLogo (logoId) {
    return axios.post('/api/company/activate-logo', { logo_id: logoId })
  },
  deleteCompanyLogo (companyId, logoId) {
    return axios.delete(`/api/company/${companyId}/logo/${logoId}`)
  },
  enableDigitalCatalog (companyId) {
    return axios.post('/api/company/enable-dc-company', { company_id: companyId })
  },

  // Admin company management methods
  fetchAdminCompanies(params) {
    return axios.get('/api/admin/companies', { params })
  },
  importCompanies(formData) {
    return axios.post('/api/admin/companies/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  exportCompanies(data) {
    return axios.post('/api/admin/companies/export', data)
  },
  bulkDeleteCompanies(ids) {
    return axios.delete('/api/admin/companies/bulk-delete', {
      data: { ids }
    })
  },
  fetchReps() {
    return axios.get('/api/users', { 
      params: { role: 'rep' } 
    })
  },

  // Create new company
  createCompany(data) {
    return axios.post('/api/admin/companies', data)
  },

  // Download company template
  downloadCompanyTemplate() {
    return axios.get('/api/admin/companies/template', {
      responseType: 'blob'
    })
  }

}
